import React from "react";
import "./Header.css";
// import { Link } from "react-router-dom";

const Header = () => {
  return (
    <div className='nav-container container'>
      <div className="logo">
        <ul>
          <li>
            <a href='/'>E-O</a>
          </li>
        </ul>
      </div>
      <div className="nav-links">
        <ul>
          <li>
            <a href='/'>Hello</a>
          </li>
          <li>
            <a href='/#work'>Portfolio</a>
          </li>
          <li>
            <a href='/#about'>About</a>
          </li>
          <li>
            <a href='/#contact'>Contact</a>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default Header;
